import { SalesPortalOrderEntryTable_OrderEntryItemFieldsFragment } from '@/types';
import { SavedCartItem } from '@/experiences/sales-portal/domain/ordering/blocs/stores/cart-store';

/**
 * Transforms an order entry item (backend entity) into a SavedCartItem (client entity).
 * Uses the shared order entry table fragment (cart and order guide use the same shape).
 *
 * @param item - The order entry item to transform
 * @returns The transformed SavedCartItem
 *
 * @example
 * ```typescript
 * const cartItems = data.getOrderEntryItemsFromCart.order_entry_items.map(useSavedOrderEntryItemTransformer);
 * ```
 */
export const useSavedOrderEntryItemTransformer = (
  item: SalesPortalOrderEntryTable_OrderEntryItemFieldsFragment,
): SavedCartItem => {
  return {
    addedAt: item.order_info?.added_at ?? null,
    orderItemUUID: item.order_info?.order_item_id ?? null,
    quantity: item.order_info?.cart_quantity ?? 0,
    variantPackUUID: item.variant_pack_id,
  };
};
